import { render, staticRenderFns } from "./EmailRecipients.vue?vue&type=template&id=0c8407e3&scoped=true"
import script from "./EmailRecipients.vue?vue&type=script&lang=js"
export * from "./EmailRecipients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8407e3",
  null
  
)

export default component.exports